import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tab-location',
  templateUrl: './tab-location.component.html',
  styleUrls: ['./tab-location.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabLocationComponent {
  @Input() locationForm: FormGroup;
  @Input() selectedTabIndex: number;
  @Input() isViewMode: boolean;
}
